import {WinPresentationController} from "../WinPresentationController";
import {TheRave} from "../../TheRave";
import {TimelineLite} from "gsap";
import {TheRaveGameMode} from "../../gameflow/TheRaveGameMode";
import {TheRaveSound} from "../../sound/TheRaveSound";

export class FreespinWinController extends WinPresentationController {

    constructor() {
        super("FreespinWinController", false);
    }

    protected hasWin():boolean {
        const data = TheRave.model.parsedGameData;
        return data.freespinTriggeredThisSpin && data.nextMode !== TheRaveGameMode.FREESPIN_SUPER;
    }

    protected async createWinAnimation():Promise<any> {
        const tl = new TimelineLite();
        let delay = 0, scatterWinNr:number = 0;
        tl.add(()=>{
            TheRave.initialCountUp.remove();
            TheRave.waysWon.remove();
            TheRave.bigWinCountUp.remove();
        });
        TheRave.model.scatterPositions!.forEach((symId:number, reelId:number) => {
            if(symId > -1) {
                scatterWinNr++;
                const symbol = TheRave.reels[reelId].getSymbol(symId);
                TheRave.reels[reelId].reelView.addWinSymbol(symbol);
                const symTl = new TimelineLite();
                symTl.to(symbol.scale, {duration : 0.3, x : 1, y : 1})
                    .to(symbol.scale, {duration : 0.5, x : 1, y : 1});
                tl.add(symTl, delay);
                delay += 0.3;
            }
        });
        if(scatterWinNr>0){
            tl.add(()=>TheRaveSound.playSoundEffect("scatterWinAttention"), 0);
        }
        tl.to(this, {duration : 0.1});
        await Promise.resolve(tl);
        await new Promise<void>(resolve => {
            TheRave.freespinIntro.show(() => {
                TheRave.keypadPlugin.setZeroBetSpinCounter(TheRave.model.parsedGameData.freespinsLeft);
                resolve();
            });
        });
    }
}